import React, { useState, useEffect } from 'react';
import { Alert, Button, Container } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';

// ADR-004 — Contas Prefeitura Sem Convênio é uma tela desktop-only (≥1024px).
// Reage a resize sem refresh para que o operador veja a mensagem mesmo redimensionando a janela.
const BREAKPOINT_DESKTOP = 1024;

const DesktopOnlyGuard = ({ children }) => {
  const [isDesktop, setIsDesktop] = useState(
    typeof window !== 'undefined' ? window.innerWidth >= BREAKPOINT_DESKTOP : true
  );
  const history = useHistory();

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= BREAKPOINT_DESKTOP);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  if (!isDesktop) {
    return (
      <Container fluid className="px-3 py-5 text-center">
        <Alert variant="warning" className="d-inline-block px-5 py-4">
          <h5 className="mb-3">Tela disponível apenas em desktop</h5>
          <p className="mb-3">
            Esta tela está disponível apenas em desktop (largura mínima de{' '}
            {BREAKPOINT_DESKTOP}px).
          </p>
          <Button variant="primary" onClick={() => history.push('/')}>
            Voltar ao início
          </Button>
        </Alert>
      </Container>
    );
  }

  return children;
};

export default DesktopOnlyGuard;
